import { ContractSchedule } from '../../../ContractSchedule'
import { Divider } from '../../../Divider'
import type { Contract } from '../../typings/Contract'

interface Props {
  contract: Contract
  onReSendWorkObstruction?: (workObstructionId: string) => any
}

export const Schedule = ({ contract, onReSendWorkObstruction }: Props) => {
  return (
    <>
      <Divider sectionSeparator={true} />
      <ContractSchedule
        contract={contract}
        onReSendWorkObstruction={onReSendWorkObstruction}
      />
    </>
  )
}
